// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__3uz8-","CloseBtn":"style_CloseBtn__3fUFz","BodyContent":"style_BodyContent__2aR2x","SendButton":"style_SendButton__20qbs"};